export const prefixObjectKeys = <T = any>(object: Record<string, T>, prefix: string) => {
  return Object.entries(object).reduce(
    (sum, next) => {
      sum[`${prefix}.${next[0]}`] = next[1]
      return sum
    },
    {} as Record<string, T>,
  )
}
